import cn from 'classnames';
import React from 'react';
import { LayoutDesktop } from '@alfa-bank/site-layout/desktop';
import { TextDesktop } from '@alfa-bank/site-text-v2/desktop';

import { useTabsPanel } from '../../hooks/use-tabs-panel';
import { RenderedHeader } from '../../tabs-header/components/rendered-header';
import type { TPanelHeaderDesktopV2Props } from '../models';

import defaultStyles from './styles/styles.css';
import withIconStyles from './styles/with-icon.css';
import { useTabsPanelV2Width } from './hooks/use-tabs-panel-v2-width';

export const PanelHeaderV2Desktop = (props: TPanelHeaderDesktopV2Props) => {
    const {
        className,
        dataTestId = 'TabsHeader',
        iconBackgroudColor = 'transparent',
        selectedID,
        theme = 'light',
        titles,
        widthTab = 'unique',
        widthTabPanel = 'fullBlock',
        withLayout = false,
    } = props;

    const {
        autoSwitch,
        debouncedProgress,
        headerContainer,
        headerList,
        selectedTab,
        tabsProps,
        withIcon,
    } = useTabsPanel(props);

    const { biggerTabWidth } = useTabsPanelV2Width({ widthTab, headerList });

    const isEqualTabWidth = widthTab === 'equal';

    const renderComponent = (
        <div
            className={cn(
                defaultStyles.backCover,
                defaultStyles[theme as keyof typeof defaultStyles],
                defaultStyles[widthTabPanel],
                {
                    [defaultStyles.withIcon]: withIcon,
                }
            )}
        >
            <RenderedHeader
                className={className}
                dataTestId={dataTestId}
                equalTabWidth={isEqualTabWidth}
                headerContainer={headerContainer}
                headerList={headerList}
                iconBackgroundColor={iconBackgroudColor}
                progress={autoSwitch && debouncedProgress}
                selectedID={selectedID}
                selectedTab={selectedTab}
                styles={withIcon ? { ...defaultStyles, ...withIconStyles } : defaultStyles}
                tabInlineStyle={{
                    minWidth: isEqualTabWidth && !!biggerTabWidth ? biggerTabWidth : undefined,
                }}
                Text={TextDesktop}
                titles={titles}
                {...tabsProps}
                iconSize={32}
                translateX={0}
            />
        </div>
    );

    return <>{withLayout ? <LayoutDesktop>{renderComponent}</LayoutDesktop> : renderComponent}</>;
};
